import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useToasts } from 'react-toast-notifications';
import { makeStyles } from "@material-ui/core/styles";
import api from '../../services/api'

import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import ClipLoader from "react-spinners/ClipLoader";

import CustomTabs from "components/CustomTabs/CustomTabs.js"
import routes from "routes.js";
import { isValidEmail } from '../../services/utils';

const styles = {
  iconInputLogin: {
    fontSize: 22,
    color: '#bbbbbb',
    marginTop: -2,
    marginLeft: 16
  },

  iconInputLoginEye: {
    fontSize: 22,
    color: '#bbbbbb',
    marginTop: -2,
    cursor: 'pointer',
    marginRight: 16
  },

  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },

  cardTitleWhite: {
    height: '30px',
    color: '#1989FF',
    fontFamily: "Open Sans",
    fontSize: '22px',
    lineHeight: '30px',
    textAlign: 'center'
  },

  container: {
    justifyContent: 'center',
    alignItems: 'center'
  },

  gridContainer: {
    height: '100vh',
    width: '100%',
    marginTop: '-70px'
  },

  company: {
    height: '38px',
    color: '#BDBDBD',
    fontFamily: "Open Sans",
    fontSize: '14px',
    lineHeight: '19px',
    textAlign: 'center'
  },

  hora: {
    color: '#1989FF',
    fontFamily: "Open Sans",
    fontSize: '30px',
    lineHeight: '20px',
    textAlign: 'center',
    fontWeight: '600',
    marginTop: '67px'
  },

  dayInfo: {
    color: '#828282',
    fontFamily: "Open Sans",
    fontSize: '12px',
    lineHeight: '16px',
    textAlign: 'center'
  },

  button: {
    borderRadius: '100px !important',
    backgroundLinearGradient: '180deg, #F5F6FB 0%, #E4E7EE 100%',
    backgroundColor: '#f8f9fd',
    color: '#1989FF',
    fontFamily: "Open Sans",
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '19px',
    textAlign: 'center',
    border: '7px solid',
    borderColor: '#e6eaf1 !important',
    textTransform: 'none'
  },

  register: {
    color: '#828282',
    fontFamily: "Open Sans",
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: '700',
    height: '10px'
  },

  registerOk: {
    color: '#828282',
    fontFamily: "Open Sans",
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: '700',
    height: '5px'
  },

  map: {
    padding: ' 0px 0px !important'
  },

  footer: {
    justifyContent: 'center',
    alignItems: 'baseline',
    display: 'grid',
    padding: '0px !important',
  },

  divRegister: {
    height: '29px'
  },

  gridItem: {
    alignItems: 'center'
  },

  grid: {
    height: '100%'
  },

  icon: {
    color: '#BDBDBD',
    fontSize: '18px'
  },

  input: {
    color: '#828282',
    fontFamily: "Open Sans",
    fontSize: '16px'
  },

  text: {
    textAlign: 'center',
    color: '#1989ff',
    fontFamily: "Open Sans",
    fontSize: '26px',
    fontWeight: '400',
    lineHeight: '42px'
  },

  textInfo: {
    color: '#828282',
    height: '0px',
    fontSize: '14px',
    textAlign: 'center',
    fontWeight: '700',
    marginTop: 10
  },
};

const useStyles = makeStyles(styles);

export default function Configuracao() {
  const history = useHistory();
  const classes = useStyles();
  const { addToast } = useToasts();
  const [senhaAtual, setSenhaAtual] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [emailAtual, setEmailAtual] = useState('');
  const [email, setEmail] = useState('');
  const [confirmarEmail, setConfirmarEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [visibleSenhaAtual, setVisibleSenhaAtual] = React.useState(false);
  const [typeSenhaAtual, setTypeSenhaAtual] = React.useState("password");
  const [visibleSenha, setVisibleSenha] = React.useState(false);
  const [typeSenha, setTypeSenha] = React.useState("password");
  const [visibleConfirmarSenha, setVisibleConfirmarSenha] = React.useState(false);
  const [typeConfirmarSenha, setTypeConfirmarSenha] = React.useState("password");

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        emailAtualUsuario();
        setLoading(false);
      } catch (err) {
        setLoading(false);
        if (err.statusCode === 401) {
          localStorage.clear();
          history.push("/");
        }
      }
    })();
  }, []);

  const onVisibleSenhaAtual = () => {
    if (visibleSenhaAtual) {
      setVisibleSenhaAtual(false);
      setTypeSenhaAtual("password");
    } else {
      setVisibleSenhaAtual(true);
      setTypeSenhaAtual("text");
    }
  }

  const onVisibleSenha = () => {
    if (visibleSenha) {
      setVisibleSenha(false);
      setTypeSenha("password");
    } else {
      setVisibleSenha(true);
      setTypeSenha("text");
    }
  }

  const onVisibleConfirmarSenha = () => {
    if (visibleConfirmarSenha) {
      setVisibleConfirmarSenha(false);
      setTypeConfirmarSenha("password");
    } else {
      setVisibleConfirmarSenha(true);
      setTypeConfirmarSenha("text");
    }
  }

  const alterarSenha = async () => {
    if (!senhaAtual) {
      addToast('Por favor, informe a senha atual!', { appearance: 'error' });
      return;
    }
    else if (!senha) {
      addToast('Por favor, informe a nova senha!', { appearance: 'error' });
      return;
    }
    else if (!confirmarSenha) {
      addToast('Por favor, confirme a nova senha!', { appearance: 'error' });
      return;
    }
    else if (senha !== confirmarSenha) {
      addToast('Nova Senha e Confirmação da Senha são diferentes!', { appearance: 'error' });
      return;
    }

    try {
      setLoading(true);
      let alteraSenha = await api.alteraSenha(senha, senhaAtual, confirmarSenha);
      if (alteraSenha.success) {
        setSenha('');
        setSenhaAtual('');
        setConfirmarSenha('');
        setLoading(false);
        addToast('Senha alterada com sucesso!', { appearance: 'success' });
      } else {
        setLoading(false);
        if (alteraSenha.statusCode === 401) {
          localStorage.clear();
          history.push("/");
        }
        addToast(alteraSenha.message, { appearance: 'error' });
      }
    } catch (err) {
      setLoading(false);
      if (err.statusCode === 401) {
        localStorage.clear();
        history.push("/");
      }
      addToast(err.message, { appearance: 'error' });
    }
  }

  const emailAtualUsuario = async () => {  
    setLoading(true);
    let usuario = await api.getUsuario();    
    if (usuario.success) {     
      setLoading(false);
      setEmailAtual(usuario.data.email);      
      return usuario;      
    }
    else {            
      setLoading(false);
      addToast(usuario.message, { appearance: 'error' });
      localStorage.clear();
      history.push("/");      
    }
  }

  const alterarEmail = async () => {
    let usuario = await emailAtualUsuario();  

    if ((!isValidEmail(emailAtual)) || (!isValidEmail(email)) || (!isValidEmail(confirmarEmail))) {      
      addToast('Há e-mail em formato não válido, por favor verifique e tente novamente!', { appearance: 'error' });      
      return;
    }    
    if (!emailAtual) {
      addToast('Por favor, informe o email atual!', { appearance: 'error' });
      return;
    }
    else if (!email) {
      addToast('Por favor, informe o novo email!', { appearance: 'error' });
      return;
    }
    else if (!confirmarEmail) {
      addToast('Por favor, confirme o novo email!', { appearance: 'error' });
      return;
    }
    else if (email !== confirmarEmail) {
      addToast('Novo email e confirmação de email são diferentes!', { appearance: 'error' });
      return;
    }

    try {
      setLoading(true);
      let alteraEmail = await api.alteraEmail(email, emailAtual, confirmarEmail);      
      if (alteraEmail.success) {
        usuario = await emailAtualUsuario();
        setEmail('');        
        setConfirmarEmail('');
        setEmailAtual(usuario.data.email);
        setLoading(false);
        addToast('Email alterado com sucesso!', { appearance: 'success' });
      } else {
        setLoading(false);
        if (alteraEmail.statusCode === 401) {
          localStorage.clear();
          history.push("/");
        }
        addToast(alteraEmail.message, { appearance: 'error' });
      }
    } catch (err) {
      console.log('quebrou');
      setLoading(false);
      if (err.statusCode === 401) {
        localStorage.clear();
        history.push("/");
      }
      addToast(err.message, { appearance: 'error' });
    }
  }

  return (
    <div className={classes.gridContainer}>
      <GridContainer style={{ position: 'fixed', justifyContent: 'center', height: '100%', alignItems: 'center', zIndex: 1 }} >
        <GridItem>
          <Card style={{
            backgroundColor: '#f8f9fd',
            borderBottomLeftRadius: 25,
            borderBottomRightRadius: 25,
            borderTopLeftRadius: 25,
            borderTopRightRadius: 25,
            borderColor: '#C8C8C8',
            borderRadius: '25px',
            height: '600px',
            width: '380px',
            textAlign: 'center',
            boxShadow: '0 1px 4px 0 rgb(0 0 0 / 40%)'
          }}>
            <CardHeader style={{ padding: '8px 5px 0px 5px', justifyContent: 'center', borderBlockEnd: '1px solid #EEEFF4', textAlign: 'center' }}>
              <label className={classes.text}>Configuração</label>
            </CardHeader>
            

            <CustomTabs 
              headerColor={"primary"}
              title={""}
              tabs={[
              {
                tabName:"SENHA",                
                tabContent:
                  <CardBody>
                    <GridItem>
                      <h2 className={classes.textInfo}>Informe a Senha Atual</h2>
                      <FormControl xs={12} sm={12} md={12} style={{ marginTop: 20 }}>
                        <Input xs={12} sm={12} md={12}
                          autoFocus={false}
                          disableUnderline
                          className={classes.input}
                          placeholder="Senha Atual"
                          inputProps={{
                            value: senhaAtual,
                            onChange: (event) => { setSenhaAtual(event.target.value) },
                            type: typeSenhaAtual
                          }}
                          startAdornment={
                            <InputAdornment position="start">
                              <i className="icon-lock-unlock" style={styles.iconInputLogin} />
                            </InputAdornment>
                          }
                          endAdornment={
                            visibleSenhaAtual ?
                              <InputAdornment position="end">
                                <i className="icon-eye-off" style={styles.iconInputLoginEye} onClick={() => onVisibleSenhaAtual()} />
                              </InputAdornment>
                              :
                              <InputAdornment position="end">
                                <i className="icon-eye" style={styles.iconInputLoginEye} onClick={() => onVisibleSenhaAtual()} />
                              </InputAdornment>
                          }
                        />
                      </FormControl>
                    </GridItem>
                        
                    <GridItem>
                      <h2 className={classes.textInfo}>Informe a Nova Senha</h2>
                      <FormControl xs={12} sm={12} md={12} style={{ marginTop: 20 }}>
                        <Input xs={12} sm={12} md={12}
                          autoFocus={false}
                          disableUnderline
                          className={classes.input}
                          placeholder="Nova Senha"
                          inputProps={{
                            value: senha,
                            onChange: (event) => { setSenha(event.target.value) },
                            type: typeSenha
                          }}
                          startAdornment={
                            <InputAdornment position="start">
                              <i className="icon-lock-1" style={styles.iconInputLogin} />
                            </InputAdornment>
                          }
                          endAdornment={
                            visibleSenha ?
                              <InputAdornment position="end">
                                <i className="icon-eye-off" style={styles.iconInputLoginEye} onClick={() => onVisibleSenha()} />
                              </InputAdornment>
                              :
                              <InputAdornment position="end">
                                <i className="icon-eye" style={styles.iconInputLoginEye} onClick={() => onVisibleSenha()} />
                              </InputAdornment>
                          }
                        />
                      </FormControl>
                    </GridItem>

                    <GridItem>
                      <h2 className={classes.textInfo}>Confirme a Nova Senha</h2>
                      <FormControl xs={12} sm={12} md={12} style={{ marginTop: 20 }} className={classes.margin}>
                        <Input xs={12} sm={12} md={12}
                          autoFocus={false}
                          className={classes.input}
                          disableUnderline
                          placeholder="Confirmar Nova Senha"
                          inputProps={{
                            value: confirmarSenha,
                            onChange: (event) => { setConfirmarSenha(event.target.value) },
                            type: typeConfirmarSenha,
                            onKeyDown: (e) => {
                              if (e.key === 'Enter') {
                                alterarSenha();
                              }
                            }
                          }}
                          startAdornment={
                            <InputAdornment position="start">
                              <i className="icon-check-double" style={styles.iconInputLogin} />
                            </InputAdornment>
                          }
                          endAdornment={
                            visibleConfirmarSenha ?
                              <InputAdornment position="end">
                                <i className="icon-eye-off" style={styles.iconInputLoginEye} onClick={() => onVisibleConfirmarSenha()} />
                              </InputAdornment>
                              :
                              <InputAdornment position="end">
                                <i className="icon-eye" style={styles.iconInputLoginEye} onClick={() => onVisibleConfirmarSenha()} />
                              </InputAdornment>
                          }
                        />
                      </FormControl>
                    </GridItem>  

                    <CardFooter style={{ justifyContent: 'center', alignItems: 'baseline', height: '100px' }}>
                      <Button style={{ borderRadius: '25px', width: 140 }} onClick={() => alterarSenha()} color="primary" disabled={loading}>Salvar</Button>
                    </CardFooter>                              
                  </CardBody>                 
              },
              {
                tabName:"EMAIL",
                tabContent:
                  <CardBody>
                    <GridItem>
                      <h2 className={classes.textInfo}>Email Atual</h2>
                      <FormControl xs={12} sm={12} md={12} style={{ marginTop: 20, width: "100%" }}>
                        <Input xs={12} sm={12} md={12}
                          autoFocus={false}
                          disableUnderline
                          className={classes.input}
                          placeholder="Email Atual"
                          disabled={true}
                          inputProps={{
                            value: emailAtual,
                            onChange: (event) => { setEmailAtual(event.target.value) },
                          }}  
                          startAdornment={
                            <InputAdornment position="start">
                              <i className="icon-email-action-unread" style={styles.iconInputLogin} />
                            </InputAdornment>
                          }                                                 
                        />
                      </FormControl>
                    </GridItem>
                        
                    <GridItem>
                      <h2 className={classes.textInfo}>Informe o Novo Email</h2>
                      <FormControl xs={12} sm={12} md={12} style={{ marginTop: 20, width: "100%" }}>
                        <Input xs={12} sm={12} md={12}
                          autoFocus={false}
                          disableUnderline
                          className={classes.input}
                          placeholder="Novo Email"
                          inputProps={{
                            value: email,
                            onChange: (event) => { setEmail(event.target.value) },
                          }}   
                          startAdornment={
                            <InputAdornment position="start">
                              <i className="icon-email-action-sync-1" style={styles.iconInputLogin} />
                            </InputAdornment>
                          }                       
                        />
                      </FormControl>
                    </GridItem>

                    <GridItem>
                      <h2 className={classes.textInfo}>Confirme o Novo Email</h2>
                      <FormControl xs={12} sm={12} md={12} style={{ marginTop: 20, width: "100%" }} className={classes.margin}>
                        <Input xs={12} sm={12} md={12}
                          autoFocus={false}
                          className={classes.input}
                          disableUnderline
                          placeholder="Confirmar Novo Email"
                          inputProps={{
                            value: confirmarEmail,
                            onChange: (event) => { setConfirmarEmail(event.target.value) },                            
                            onKeyDown: (e) => {
                              if (e.key === 'Enter') {
                                alterarEmail();
                              }
                            }
                          }} 
                          startAdornment={
                            <InputAdornment position="start">
                              <i className="icon-email-action-check" style={styles.iconInputLogin} />
                            </InputAdornment>
                          }                          
                        />
                      </FormControl>                      
                    </GridItem>  

                    <CardFooter style={{ borderRadius: '25px', justifyContent: 'center', alignItems: 'baseline', height: '100%' }}>
                      <Button style={{ borderRadius: '25px', width: 140 }} onClick={() => alterarEmail()} color="primary" disabled={loading}>Salvar</Button>
                    </CardFooter>                              
                  </CardBody>                                 
                }
              ]}
              rtlActive={true}
              plainTabs={false}
            />
           
        
            <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
              <ClipLoader
                size={80}
                color={"#364e6b"}
                loading={loading}
                css={{ border: '8px solid', borderBottomColor: 'transparent' }}
              />
            </div>
          </Card>
        </GridItem>
      </GridContainer>
    </div>    
       
    
    
  );
}